module.exports = __webpack_public_path__ + "static/media/game-quitbutton.66f76d0d.png";